import { render, staticRenderFns } from "./TenantSelector.vue?vue&type=template&id=fad4c468&scoped=true&"
import script from "./TenantSelector.vue?vue&type=script&lang=ts&"
export * from "./TenantSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TenantSelector.vue?vue&type=style&index=0&id=fad4c468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad4c468",
  null
  
)

export default component.exports